import axios from 'axios';
import { BFF_BASE_URL } from '../services/constants';
import isMobile from '../utils/is-mobile';

axios.defaults.baseURL = BFF_BASE_URL;

function getToken() {
  return sessionStorage.getItem('token');
}

axios.interceptors.request.use(config => {
  const newConfig = config;

  if (getToken()) {
    newConfig.headers.Authorization = `Bearer ${getToken()}`;
    newConfig.headers.origem = isMobile() ? 'webmobile' : 'web';
    return newConfig;
  }
  window.location.href = '/login';
  return config;
});

axios.interceptors.response.use(
  response => response.data ?? response,
  error => Promise.reject(error)
);

export { axios as api };
